import { core, safeToNumber } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

/**
 * Fetch roles for the given partner.
 *
 * @returns {Object} A redux TockApi action.
 */
export function fetchRoles(): ApiAction {
  return {
    TockApi: {
      getListProto: '/partner/patron/role',
      type: AppConstants.PARTNER_ROLE_FETCH_ALL,
    },
  };
}

/**
 * Insert a patron's assigned role.
 *
 * @param {Object} assignedPatronRole to insert for a patron.
 * @returns {Object} A redux TockApi action.
 */
export function addRole(assignedPatronRoles: core.AssignedPatronRole): ApiAction {
  return {
    TockApi: {
      postProto: '/partner/patron/role',
      type: AppConstants.PARTNER_ROLE_ADD,
      request: assignedPatronRoles,
      toast: 'Team member(s) added',
    },
  };
}

/**
 * Update a patron's assigned role.
 *
 * @param {Object} assignedPatronRole to update for a patron.
 * @returns {Object} A redux TockApi action.
 */
export function updateRole(assignedPatronRole: core.AssignedPatronRole): ApiAction {
  return {
    TockApi: {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      putProto: `/partner/patron/${safeToNumber(assignedPatronRole.patron!.id)}/role`,
      type: AppConstants.PARTNER_ROLE_UPDATE,
      request: assignedPatronRole.roles,
      toast: 'Team member updated',
    },
  };
}
